module.exports = __webpack_public_path__ + "img/rcrclc_sjc.cde9db61.png";